module.exports = __webpack_public_path__ + "img/PM.f09b1365.svg";